/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_Pagetitle1Inputs */

const ja_contact_meta_pagetitle1 = /** @type {(inputs: Contact_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact`)
};

const en_contact_meta_pagetitle1 = /** @type {(inputs: Contact_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact`)
};

/**
* | output |
* | --- |
* | "contact" |
*
* @param {Contact_Meta_Pagetitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_meta_pagetitle1 = /** @type {((inputs?: Contact_Meta_Pagetitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_Pagetitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_meta_pagetitle1(inputs)
	return en_contact_meta_pagetitle1(inputs)
});
export { contact_meta_pagetitle1 as "contact_meta_pageTitle" }